import React from "react";
import { Container } from 'react-bootstrap';

import WOW from "wowjs";

class Hero extends React.Component {

	componentDidMount() {
    	new WOW.WOW().init();
  	}
  	render() {
		return (
			<div className="HereoBanner automotive-back">
			    <div className="Banner_Content">
					<Container fluid>
						<h2 className="pagehead-title wow fadeInUp">BANKING & FINANCE</h2>
						<div className="red-border"> </div>
						<p>Manage your workflow better with digiPanda' innovative IT solutions and services tailored specifically for banks and financial institutions.</p>
					</Container>
				</div>
			</div>
		);
	}
};

export default Hero;
